<template>
  <f7-page>
    <div v-if="!loaded" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader></f7-preloader>
        <div class="preloader-text">
          {{ $t('loading') }}
        </div>
      </div>
    </div>
    <div v-if="loaded" class="main-offer-card">
      <div class="summary-header">
        <div class="summary-title">
          <div class="summary-icon-sample-details"></div>
          <div class="summary-text">{{ $t('sample_detail') }}</div>
        </div>

        <div class="summary-actions">
          <button
            class="download-button"
            @click="$refs.sampleSummary.download()"
            :disabled="currentSampleSummary.status_code !== '3'"
          >
            {{ $t('download') }}
          </button>
        </div>
      </div>
      <div v-if="!isFinished" class="warning-message">
        {{ $t('provisionalResultsMessage') }}
      </div>

      <MiningSampleSummary ref="sampleSummary" />
      <br />
      <MiningSamplesDetailTable
        class="custom-table-container-mining"
        v-if="showDetails"
        :store="customStore"
      />

      <NotificationSpinner
        v-if="!showDetails"
        :message="$t('pendingPaymentSampleResult')"
        :alert="true"
      />

      <!-- <NotificationSpinner
        v-if="inProcess"
        :message="$t('inProcessSampleResult')"
        :warning="true"
      /> -->
    </div>
  </f7-page>
</template>

<script>
import MiningSampleSummary from '@/components/Mining/SamplesDetails/Summary/index.vue';
import MiningSamplesDetailTable from '@/components/Mining/SamplesDetails/Table/index.vue';
import { mapActions, mapState } from 'vuex';
import EventBus from '@/services/event-bus';
import NotificationSpinner from '@/components/NotificationSpinner/index.vue';
import { NOTIFY_TIME_LONG } from '@/js/constants';

export default {
  name: 'MiningSamplesDetailsPage',
  components: {
    MiningSamplesDetailTable,
    MiningSampleSummary,
    NotificationSpinner,
  },
  data() {
    return {
      loaded: false,
      customStore: null,
      currentSampleSummary: {},
    };
  },
  computed: {
    urlName() {
      // Si accede al detalle de una muestra desde una factura, vuelve al listado de facturas
      if (this.lastRouteIssuedInvoicesList) {
        return 'issuedInvoicesList';
      }
      return this.lastRouteHome ? 'Home' : 'MiningSamplesPage';
    },
    showDetails() {
      return this.currentSampleSummary?.status_code !== '5';
    },
    inProcess() {
      return this.currentSampleSummary?.status_code === '2';
    },
    isFinished() {
      return this.currentSampleSummary?.status_code === '3';
    },
    ...mapState('filter', ['currentSampleId']),
    ...mapState('samples', [
      'lastRouteHome',
      'lastRouteIssuedInvoicesList',
    ]),
  },
  async beforeMount() {
    try {
      this.loaded = false;
      this.currentSampleSummary =
        await this.getCurrentSampleBasedOnFilter();
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(
              JSON.parse(error.message).error
            )
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    } finally {
      this.loaded = true;
    }
  },
  async mounted() {
    try {
      this.loaded = false;

      EventBus.$on(
        'miningDetailsFilteredSamples',
        async ({ id, params }) => {
          if (params) {
            this.customStore = await this.getStoreDetailsWithFilters({
              id,
              paramFilters: params,
            });
          } else {
            this.customStore = await this.getDetailsStore();
          }
        }
      );

      this.customStore = await this.getDetailsStore();
    } catch (error) {
      this.customStore = null;
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(
              JSON.parse(error.message).error
            )
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    } finally {
      this.loaded = true;
    }

    // if (!this.showDetails) {
    //   this.$notifyDX(
    //     {
    //       message: this.$t('pendingPaymentSampleResult'),
    //       width: 550,
    //     },
    //     'warning',
    //     7000
    //   );
    // }
  },
  methods: {
    ...mapActions('miningSamples', [
      'getDetailsStore',
      'getStoreDetailsWithFilters',
    ]),
    ...mapActions('filter', ['setCurrentFilter']),
    ...mapActions('samples', ['getCurrentSampleBasedOnFilter']),
  },
};
</script>
<style>
.main-offer-card {
  background-color: white; /* fondo gris suave */
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(87, 84, 95, 0.3);
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
  overflow-x: clip;
}
.summary-title {
  gap: 10px;
  margin-bottom: 16px;
}

.summary-icon-sample-details {
  width: 24px;
  height: 24px;
  background-image: url('@/static/icons/ic_detalle_muestra.svg');
}

.summary-text {
  font-size: 18px;
  font-weight: 600;
  color: #00346a; /* o el color que uses para encabezados */
}

/* .custom-table-container {
  width: 100% !important;
  max-width: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
  box-sizing: border-box;
} */

.download-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #00346a;
  color: #fff;
  font-weight: 500;
  border: none;
  border-radius: 10px;
  padding: 8px 20px 8px 40px;
  cursor: pointer;
  font-size: 14px;
  line-height: 140%;
  background-image: none !important;
  white-space: nowrap;
  min-width: 140px;
  max-width: 160px;
}

.download-button::before {
  content: '';
  position: absolute;
  left: 12px; /* ligeramente más cerca del borde */
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  background-image: url('@/static/icons/download.svg');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
}

/* Hover */
.download-button:hover:not(:disabled) {
  background-color: #004b93;
}

/* Deshabilitado */
.download-button:disabled {
  background-color: #e5e4e7;
  color: #8a8693;
  border: 1px solid #8a8693;
  cursor: not-allowed;
}

.download-button:disabled::before {
  filter: grayscale(100%) brightness(1.8);
  opacity: 0.7;
}
</style>
